/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type TradePromo_user$ref = any;
export type PdpSharedPromoCode_user$ref = any;
export type PdpSharedPromoCode_user = {
    readonly activePromotion: {
        readonly code: string | null;
    } | null;
    readonly tradeFirm?: {
        readonly rewards: {
            readonly currentPromoSegment: {
                readonly segmentCode: string | null;
            } | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": TradePromo_user$ref;
    readonly " $refType": PdpSharedPromoCode_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedPromoCode_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "itemId",
            "type": "String"
        },
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        },
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String"
        }
    ],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "activePromotion",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "itemId",
                    "variableName": "itemId"
                }
            ],
            "concreteType": "Promotion",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "code",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tradeFirm",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "rewards",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "currentPromoSegment",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "userId",
                                            "variableName": "userId"
                                        }
                                    ],
                                    "concreteType": "currentPromoSegmentType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "segmentCode",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "TradePromo_user",
                    "args": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '0c4e3b6815dc158e2e2b682ebf36a2ed';
export default node;
